/**
 *
 * @param data hierarchical data
 * @param nodeId node to extract
 * @param prop what property to check
 * @returns the node with all its descendants
 */
export const getNode: <T extends { children?: Array<T> }>(data: T, nodeId: string, prop: string) => T = (data, nodeId, prop) => {
  const recursion = (children) => children.reduce((collection, child) => {
      // if we want to keep the child at this level we collect it
      if (child[prop] === nodeId) {
        return collection.concat(child);
      }

      // if has children we recurse
      if (child.children) {
        return collection.concat(recursion(child.children));
      }

      // if the child does not have children we return what we have collected so far
      return collection;
    }, []);

  return {
    ...data,
    children: recursion(data.children)
  };
};
